module.exports = __webpack_public_path__ + "static/media/img_technical_02.573c1e13.png";